export default "__VITE_ASSET__BDyB$qD___"